import MFELink from '@components/MFELink/MFELink';
import { IconButton, List, NoResults, NoResultsIcon, SettingsIcon } from '@onsolve/onsolve-ui-components';
import React from 'react';
import AnnouncementsListRow from 'components/Announcement/AnnouncementsListRow';
import styles from './NotificationList.module.scss';
import { t } from '@lingui/macro';
export const NotificationList = ({ handleSettingsClick, data = [], userTimeZone = {}, handleTogglePopover, }) => {
    const announcementsUrl = '/support-training/announcements-inbox';
    const noAnnouncmentsRender = () => {
        return (<NoResults image={<NoResultsIcon size={'5x'}></NoResultsIcon>} description={''} title={<span className={styles.noResults}>{t `ng_components_noResultsTitle`}</span>}></NoResults>);
    };
    return (<div className={styles.notificationList} data-testid="NotificationList">
            <div className={styles.notificationList_title}>
                <div>
                    <span>{t `Announcements`}</span>
                </div>
                <div className={styles.notificationsTitles_list}>
                    <IconButton aria-label={`Notification Settings`} onClick={handleSettingsClick}>
                        <SettingsIcon size={'sm'} className={styles.settingsGearIcon} color="primary"/>
                    </IconButton>
                </div>
            </div>
            <List className={styles.listStyle} items={data} scrollable noResultRender={noAnnouncmentsRender}>
                {({ item }) => (<MFELink target="_top" to={announcementsUrl} requiresJWT={false} onClick={handleTogglePopover}>
                        <AnnouncementsListRow key={item.id} dataItem={item} userTimeZone={userTimeZone}/>
                    </MFELink>)}
            </List>

            <div className={styles.viewAll}>
                <MFELink className={styles.viewAllButton} target="_top" to={announcementsUrl} requiresJWT={false} onClick={handleTogglePopover}>
                    {t `View All`}
                </MFELink>
            </div>
        </div>);
};
